import { render } from "./LivenessVerificationV2.vue?vue&type=template&id=75b1c6c3&scoped=true"
import script from "./LivenessVerificationV2.vue?vue&type=script&lang=js"
export * from "./LivenessVerificationV2.vue?vue&type=script&lang=js"

import "./LivenessVerificationV2.vue?vue&type=style&index=0&id=75b1c6c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b1c6c3"]])

export default __exports__